import { render, staticRenderFns } from "./AppScrollButton.vue?vue&type=template&id=4e2e3d3e"
import script from "./AppScrollButton.vue?vue&type=script&lang=js"
export * from "./AppScrollButton.vue?vue&type=script&lang=js"
import style0 from "./AppScrollButton.vue?vue&type=style&index=0&id=4e2e3d3e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports